module.exports = __webpack_public_path__ + "fonts/Lufthansa Head Light.6f266028.woff";